module.exports = __webpack_public_path__ + "media/danceit.88bef9b8.mp4";